module.exports = __webpack_public_path__ + "static/media/QRcode3.4c0fcc5a.png";